module.exports = __webpack_public_path__ + "static/media/fastFilling.8327ab05.svg";